{
  "user": {
    "title": "Tableau de bord",
    "greeting": "Bon retour",
    "greetingNamed": "Bon retour, {{name}}",
    "description": "Accédez à un réglage ou reprenez là où vous en étiez.",
    "quickActions": "Actions rapides",
    "accountTitle": "Compte",
    "accountDescription": "Mettez à jour votre profil et vos informations personnelles.",
    "securityTitle": "Sécurité",
    "securityDescription": "Gérez votre mot de passe et l'authentification à deux facteurs.",
    "notificationsTitle": "Notifications",
    "notificationsDescription": "Choisissez comment et quand vous contacter.",
    "activityTitle": "Activité récente",
    "activityEmptyTitle": "Aucune activité récente",
    "activityEmptyDescription": "Votre activité récente apparaîtra ici."
  },
  "admin": {
    "title": "Aperçu administrateur",
    "greeting": "Bon retour",
    "greetingNamed": "Bon retour, {{name}}",
    "description": "Administration de la plateforme en un coup d'œil.",
    "quickActions": "Gérer",
    "usersTitle": "Utilisateurs",
    "usersDescription": "Consultez, invitez et gérez les utilisateurs de la plateforme.",
    "tenantsTitle": "Locataires",
    "tenantsDescription": "Configurez les locataires et leur image de marque.",
    "analyticsTitle": "Analytique",
    "analyticsDescription": "Suivez l'utilisation et les métriques de la plateforme.",
    "siteTitle": "Site",
    "siteDescription": "Modifiez et publiez le site marketing.",
    "featureFlagsTitle": "Indicateurs de fonctionnalités",
    "featureFlagsDescription": "Déployez des fonctionnalités auprès des locataires et des utilisateurs.",
    "pluginsTitle": "Extensions",
    "pluginsDescription": "Gérez les extensions installées et leur disponibilité."
  },
  "metrics": {
    "heading": "Aperçu",
    "chartsHeading": "Activité",
    "totalUsers": "Utilisateurs au total",
    "apiUsage": "Requêtes API",
    "errorRate": "Taux d'erreur",
    "errorRateElevated": "Au-dessus du seuil attendu",
    "growth": "Nouveaux utilisateurs",
    "featureUsage": "Utilisation des fonctionnalités",
    "attention": "Attention",
    "apiUsageChart": "Requêtes API par route",
    "featureUsageChart": "Utilisation des fonctionnalités",
    "chartEmpty": "Aucune donnée pour cette période"
  },
  "range": {
    "label": "Période",
    "24h": "Dernières 24 heures",
    "24h_short": "24 h",
    "7d": "7 derniers jours",
    "7d_short": "7 j",
    "30d": "30 derniers jours",
    "30d_short": "30 j"
  },
  "state": {
    "loading": "Chargement des métriques du tableau de bord",
    "emptyTitle": "Pas encore d'analytique",
    "emptyBody": "Les métriques apparaîtront ici à mesure que les gens utilisent votre application.",
    "errorTitle": "Impossible de charger vos métriques",
    "errorBody": "Une erreur s'est produite lors du chargement des métriques. Veuillez réessayer.",
    "retry": "Réessayer"
  }
}
